import React from 'react';
import {
  Box,
  Button,
  Drawer,
  Stack,
  Typography,
} from '@mui/material';

const InstallPromptSheet = ({
  open,
  platform,
  onNotNow,
  onInstall,
}) => {
  if (!open || !platform) {
    return null;
  }

  const isAndroid = platform === 'android';

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onNotNow}
      slotProps={{
        paper: {
          sx: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            pb: 2,
          },
        },
      }}
    >
      <Box sx={{ px: 2.5, pt: 2.5, pb: 1, maxWidth: 560, mx: 'auto', width: '100%' }}>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
          Add Quailgame to your Home Screen
        </Typography>

        {isAndroid ? (
          <Typography variant="body2" color="text.secondary">
            Install the app for faster access and a more native mobile experience.
          </Typography>
        ) : (
          <>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              In iPhone Safari, use these steps to add the app:
            </Typography>
            <Box
              component="ol"
              sx={{
                color: 'text.secondary',
                pl: 2.5,
                m: 0,
                '& li': { mb: 0.5 },
              }}
            >
              <li>Tap the Share button in Safari.</li>
              <li>Scroll and tap Add to Home Screen.</li>
              <li>Tap Add in the top-right.</li>
            </Box>
          </>
        )}

        <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ mt: 2 }}>
          <Button onClick={onNotNow} variant="text">
            Not now
          </Button>
          {isAndroid && (
            <Button onClick={onInstall} variant="contained" color="primary">
              Install
            </Button>
          )}
        </Stack>
      </Box>
    </Drawer>
  );
};

export default InstallPromptSheet;

